import { PresentationViewer as MigratedPresentationViewer } from '../features/presentations'

/**
 * Presentation Viewer Page Component
 *
 * This is a wrapper that exports the migrated PresentationViewer from the presentation-app.
 * The actual implementation is in frontend/src/features/presentations/pages/PresentationViewer.tsx
 *
 * This component is used in the App.tsx routing and passes through to the migrated component.
 */
export default function PresentationViewerPage() {
  return <MigratedPresentationViewer />
}
